import { imgServerBaseUrl } from "network/api-routes";

// Local check on purpose. The shared isAbsoluteUrl (network/helpers) is fixed now and also matches https:// URLs with a path,
// but this helper keeps its own regex so it does not depend on that module's behavior.
const ABSOLUTE_URL = /^(https?:)?\/\//i;

// Returns undefined (no <img> request) when the user has no profile picture.
export const userAvatarSrc = (profilePic, base = imgServerBaseUrl) => {
  if (!profilePic || profilePic === "null" || profilePic === "undefined") return undefined;
  if (ABSOLUTE_URL.test(profilePic)) return profilePic;
  return `${String(base || "").replace(/\/+$/, "")}/${String(profilePic).replace(/^\/+/, "")}`;
};
